import { Banner, SpaceBetween, spacing, styled, TextElement } from '@lessonup/ui-components';
import React from 'react';
import { Trans } from 'react-i18next';
import { useEditorTranslation } from '../../../../hooks/useEditorTranslation';
import { TabConfig } from './ShareLessonModal.types';

interface TabContentProps {
  leftImagePath: string;
  rightTitleKey: TabConfig['titleKey'];
  rightBodyTextKey: TabConfig['bodyTextKey'];
  linkTextKey?: TabConfig['linkTextKey'];
  linkUrlKey?: TabConfig['linkUrlKey'];
  banner?: TabConfig['banner'];
}

export function TabContent({
  leftImagePath,
  rightTitleKey,
  rightBodyTextKey,
  banner,
  linkTextKey,
  linkUrlKey,
}: TabContentProps) {
  const { t } = useEditorTranslation();

  return (
    <StyledContent direction="y" spacing={spacing.size8}>
      {banner && <StyledBanner paragraph={t(banner)} priority="medium" />}
      <SpaceBetween direction="x" spacing={spacing.size8}>
        <StyledImage alt="file-type-lesson" src={leftImagePath} />
        <div>
          <TextElement textStyle="bodyText" weight="bold">
            {t(rightTitleKey)}
          </TextElement>
          <TextElement textStyle="bodyText">{t(rightBodyTextKey)}</TextElement>
          {linkTextKey && linkUrlKey && (
            <TextElement textStyle="bodyText">
              <Trans
                i18nKey={t(linkTextKey)}
                t={t}
                components={[
                  <a key="0" href={t(linkUrlKey)} target="_blank" rel="noreferrer">
                    {t(linkTextKey)}
                  </a>,
                ]}
              />
            </TextElement>
          )}
        </div>
      </SpaceBetween>
    </StyledContent>
  );
}

const StyledContent = styled(SpaceBetween)`
  width: 31rem;
  align-items: flex-start;
  justify-content: center;
  margin: 0 ${spacing.size16};
`;
const StyledImage = styled.img`
  max-width: 162px;
  width: 40%;
  margin-right: ${spacing.size32};
`;

const StyledBanner = styled(Banner)`
  padding: ${spacing.size8} ${spacing.size16};
`;
